// extracted by mini-css-extract-plugin
module.exports = {"debug":"Reminder_debug__2PwGp","loading":"Reminder_loading__JjO10","remove":"Reminder_remove__1sIcZ"};